import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const NavigationContext = createContext();
export const useNavigation = () => useContext(NavigationContext) || {}; // Safety fallback

export const NavigationProvider = ({ children }) => {
    const [history, setHistory] = useState(() => {
        try {
            const savedHistory = localStorage.getItem('esl_nav_history');
            return savedHistory ? JSON.parse(savedHistory) : [{ page: 'landing', data: null }];
        } catch (e) { return [{ page: 'landing', data: null }]; }
    });

    useEffect(() => {
        localStorage.setItem('esl_nav_history', JSON.stringify(history));
    }, [history]);

    const currentPage = history[history.length - 1]?.page || 'landing';
    const currentPageData = history[history.length - 1]?.data || null;

    const navigateTo = useCallback((page, data = null) => {
        setHistory(prev => [...prev, { page, data }]);
        window.scrollTo(0, 0);
    }, []);

    const clearNavigation = useCallback(() => {
        localStorage.removeItem('esl_nav_history');
        setHistory([{ page: 'landing', data: null }]);
    }, []);

    const navigateBack = useCallback(() => {
        setHistory(prev => prev.length > 1 ? prev.slice(0, -1) : prev);
    }, []);

    const value = { currentPage, currentPageData, navigateTo, navigateBack, clearNavigation };

    return (
        <NavigationContext.Provider value={value}>
            {children}
        </NavigationContext.Provider>
    );
};